import selectedToolsIcon from '@/assets/selected_tools_icon.png';
import toolsIcon from '@/assets/tools_icon.png';
import { Text } from "@mantine/core";
import MenuTab from "./MenuTab";

interface ToolsMenuItemProps {
    children?: React.ReactNode;
}

const ToolsMenuItem: React.FC<ToolsMenuItemProps> = ({ children }) => (
    <MenuTab item='tools' label='Tools' icon={toolsIcon} selectedIcon={selectedToolsIcon} title={<Text size='md'>Tools</Text>}>
        {children}
    </MenuTab>
);

export default ToolsMenuItem;
